import React from 'react';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Experience from '../components/Experience';
import Promociones from '../components/Promociones';
import Gallery from '../components/Gallery';
import LocationContact from '../components/LocationContact';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';

export default function LandingPage() {
  return (
    <div data-testid="landing-page" style={{ background: '#0D0D0D' }}>
      <Hero />
      <Products />
      <Experience />
      <Promociones />
      <Gallery />
      <LocationContact />
      <CallToAction />
      <Footer />
    </div>
  );
}
